<template>
  <div class="cover" :style="bgStyle">
    <h2><slot /></h2>
  </div>
</template>

<script>
export default {
  name: 'SpreadMessage',
  props: {
    bgUrl: {
      type: String,
      required: true,
    },
  },
  computed: {
    bgStyle() {
      return {
        background: this.bgUrl,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.cover {
  font: 40px/1.35em oswald-medium, oswald, sans-serif;
  text-transform: uppercase;
  width: 100%;
  background-size: cover;
  height: calc(100vh - 100px);
  background-position: center center;
  color: white;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  text-shadow: 1px 1px 20px $color-grayscale-900;
}
</style>
